import React from 'react';

const Anchor = React.memo(({ anchorKey, type }) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  /* @__PURE__ */ React.createElement("div", { key: anchorKey, type, "data-hook": anchorKey })
));

export { Anchor as default };
//# sourceMappingURL=Anchor.js.map
